export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
};

export const getActiveFiltersFromCookie = (filter) => {
  const allActiveFilters = getCookie(filter);
  if (allActiveFilters) {
    return JSON.parse(allActiveFilters);
  }
  return null;
};

export const getFilterFromCookie = (filter) => {
  return getCookie(filter);
};
